/* eslint-disable max-len */
import { StaticContent } from 'types/interface';
import theme from 'themes/onedayonly';
import resourceUrl from '../../../util/make-url';
import config from '../../../util/load-config';

const blue: string = theme.colors.blue;
const lightBlue: string = theme.colors.lightBlue;

export type StaticContentSlug =
  | 'about-us'
  | 'terms-and-conditions'
  | 'competitions'
  | 'about-pargo';

const content: StaticContent[] = [
  {
    slug: 'about-us',
    contentTitle: 'About Us',
    header: {
      title: 'What is OneDayOnly all about?',
    },
    meta: {
      title: 'About us | OneDayOnly',
      keywords: 'onedayonly, about us',
      description:
        'We get our hands on everything from gadgets to groceries, slash their prices and then offer them to you for one day only. Visit us today.',
    },
    body: [
      [
        {
          copy: `<p>We get our hands on everything from gadgets to groceries, slash their prices and then offer them to you for one day only. How? Every night at 00:00 we wipe the slate clean and feature a whole new set of deals. You've got 24 hours to take advantage! Once you&apos;ve chosen what you want, your order will be delivered to your door in 5-10 working days.
          </p>`,
        },
      ],
      [
        {
          title: "What's in it for you?",
          copy: `
          <div style="display: flex;flex-wrap: nowrap; margin-top:20px;">
            <div style="width: 140px; margin-right: 30px; text-align: center;">
              <img width="100%" src="https://odo.imgix.net/resources/images/frontend/1.png"
              alt="discounts"/>
              <p style="margin-top: 10px; font-family: Montserrat, sans-serif; line-height: 1.3rem!important;"><b>Crazy deals and discounts - up to 80% off</b><p>
            </div>
            <div style="width: 140px; margin-right: 30px; text-align: center;">
              <img width="100%" src="https://odo.imgix.net/resources/images/frontend/2.png"
              alt="new deals"/>
              <p style="margin-top: 10px; font-family: Montserrat, sans-serif; line-height: 1.3rem!important;"><b>New deals every single day</b></p>
            </div>
            <div style="width: 140px; margin-right: 30px; text-align: center;">
              <img width="100%" src="https://odo.imgix.net/resources/images/frontend/3.png"
              alt="huge variety"/>
              <p style="margin-top: 10px; font-family: Montserrat, sans-serif; line-height: 1.3rem!important;"><b>Huge variety of products</b></p>
            </div>
            <div style="width: 140px; text-align: center;">
              <img width="100%" src="https://odo.imgix.net/resources/images/frontend/4.png"
              alt="customer service"/>
              <p style="margin-top: 10px; font-family: Montserrat, sans-serif; line-height: 1.3rem!important;"><b>Excellent customer service</b></p>
            </div>
          </div>`,
        },
      ],
      [
        {
          //TODO:: replace https://www.onedayonly.co.za/subscribe/campaign/ with new system subs campaign url when Nemo-927 is done
          title: 'Other really important things to know',
          copy: `<h3>What is AnotherDayOnly?</h3>
          <p>Every month (usually on the last Thursday) we bring our best deals back for one more day.</p>
          <h3>And this lunchtime deal thing?</h3>
          <p>At 1pm Monday to Sunday we release a new deal for one hour only. Be fast or come last.</p>
          <h3>Be the first in on the action</h3>
          <p>Our newsletter serves as a handy daily reminder to head over to our site to check out the rest of our crazy-good products and prices. <a href="https://link.onedayonly.co.za/join/6kh/signup" target="_blank">Sign up here</a>.</p>
          <div style="display: flex !important; align-items:center; margin-top: 30px; padding: 15px;
          background: #e5f4fa;background-clip: padding-box; border-radius:8px;">
            <div>
            Just for fun, we're on
            </div>
              <a href=${
                config.social.twitterPageUrl
              } target="_blank" rel="external nofollow" title="Follow us on X">
              <img width="100%" src=${resourceUrl('odo/assets/x-blue.png', {
                width: 30,
                isAssetUrl: true,
              })}
              style="margin-left: 10px; margin-right: 5px;"
              alt="x"/>
              </a>

              <a href=${
                config.social.instagramUrl
              } target="_blank" rel="external nofollow" title="Follow us on Instagram">
              <img width="30px" src=${resourceUrl(
                'odo/assets/instagram-blue.png',
                {
                  width: 30,
                  isAssetUrl: true,
                }
              )}
              style="margin-right: 5px;"
              alt="instagram"/>
              </a>

              <a href=${
                config.social.facebookPageUrl
              } target="_blank" rel="external nofollow" title="Follow us on Facebook">
              <img width="100%" src=${resourceUrl(
                'odo/assets/facebook-blue.png',
                {
                  width: 30,
                  isAssetUrl: true,
                }
              )}
              style="margin-right: 5px;"
              alt="facebook"/>
              </a>

              <a href=${
                config.social.linkedinUrl
              } target="_blank" rel="external nofollow" title="Follow us on LinkedIn">
              <img width="100%" src=${resourceUrl(
                'odo/assets/linkedin-blue.png',
                {
                  width: 30,
                  isAssetUrl: true,
                }
              )}
              style="margin-right: 5px;"
              alt="linkedin"/>
              </a>

              <a href=${
                config.social.tiktokUrl
              } target="_blank" rel="external nofollow" title="Follow us on TikTok">
              <img width="100%" src=${resourceUrl(
                'odo/assets/tiktok-blue.png',
                {
                  width: 30,
                  isAssetUrl: true,
                }
              )}
              alt="tiktok"/>
              </a>
          </div>
          `,
        },
      ],
    ],
  },
  {
    slug: 'terms-and-conditions',
    contentTitle: 'Terms and Conditions',
    header: {
      title: 'Terms and Conditions',
    },
    meta: {
      title: 'Terms and Conditions',
      keywords: 'onedayonly, terms and conditions',
      description: 'Terms and Conditions!',
    },
    body: [
      [
        {
          copy: `<h3>1. General</h3>
          <p>
          1.1 For purposes of these General Terms and Conditions and elsewhere on the website, &quot;OneDayOnly&quot; means OneDayOnly Offers (Pty) Ltd, Reg nr: 2009/020929/07. OneDayOnly's head office is located at Unit G06 - The Old Castle Brewery, 6 Beach Road, Woodstock, 7925, South Africa; email address: customerservice@onedayonly.co.za
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>2. Application</h3>
          <p>
          2.1 These General Terms and Conditions will apply to any and all agreements and legal relations pursuant to which OneDayOnly acts as supplier of items.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>3. Product specifications; pricing; ttypographical errors</h3>
          <p>
          3.1 OneDayOnly will not be required to execute an order or compensate a buyer for any loss if OneDayOnly made an error when presenting the item, formulating its characteristics or specifications, or stating its price, and
        </p>
        <p>
        i) it should have been clear to the buyer that such involved a printing or clerical error; or
        ii) if the buyer should not, under the circumstances, have reasonably relied on OneDayOnly delivering quoted item, with stated characteristics, at this price.

        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>4. Prices</h3>
          <p>
          4.1 Products sold by OneDayOnly are billed in Rands and include
          VAT.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>5. Market</h3>
          <p>
          5.1 Items are currently delivered to buyers in the Republic of
          South Africa. Purchase agreements are concluded with natural
          persons not acting in the course of a profession or business
          only. Therefore any VAT charged will not at any time be
          refunded.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>6. Costs of Delivering the Items</h3>
          <p>
          6.1 All prices of the items posted on the website are exclusive
          of delivery costs.
        </p>
        <p>
          6.2 Delivery costs will be stated separately when settling the
          order and may vary daily and for each order.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>7. Delivery and Delivery Period</h3>
          <p>
          7.1 OneDayOnly shall endeavour to supply the items ordered to the delivery address within 5 - 10 working days of the order confirmation and the required receipt of payment, unless otherwise stated. Prior to delivering an order, the customer may be contacted to verify the correctness of the order. This may cause some delay in delivery. When registering, buyers must state a telephone number on which they can be reached during the day (such as their number at work or a mobile phone number), so that the delay, if any, will be as short as possible.
        </p>
        <p>
        7.2 OneDayOnly shall arrange delivery by post or dispatch orders in any other way, at OneDayOnly's sole discretion. Note that a signature will be required for receipt of all residential deliveries.
        </p>
        <p>
        7.3 OneDayOnly may dispatch the delivery in parts, however, any extra costs for such additional deliveries will be borne by OneDayOnly.
        </p>
        <p>
        7.4 OneDayOnly uses third party couriers to deliver goods. A valid proof of delivery or courier run-sheet will be conclusive proof that the parcel was delivered to the address provided on the order. It is the customer&apos;s responsibility to ensure the accuracy of the delivery address.
        </p>
        <p>
        7.5 Addresses may be amended on a customer&apos;s My Orders page. In the event that no amendment is possible from this page, the goods may already be in transit and an address change may not be possible. Address changes after goods have already been processed may incur additional shipping charges.
        </p>
        <p>
        7.6 The onus is on the Customer to inform OneDayOnly if an order or part of an order is undelivered within 30 calendar days from the date of sale. OneDayOnly will not entertain any claim for undelivered items outside of 30 calendar days from the date of sale where a valid dispatch reflects against the order.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>8. Stock Availability</h3>
          <p>
          8.1 Stock on offer is limited. OneDayOnly shall take all reasonable efforts to discontinue the offer as soon as stock is no longer available. However, should items still be offered after stocks are sold, OneDayOnly shall only be liable to refund monies where it is unable to fulfil orders at advertised prices.
        </p>
        <p>8.2 OneDayOnly shall endeavour to fulfil a customer&apos;s order to the best of their abilities. However, circumstances outside of OneDayOnly&apos;s control may arise where a customer&apos;s order may not be fulfilled e.g. damaged stock or stock unavailability from OneDayOnly&apos;s supplier. In cases like these, OneDayOnly shall only be liable to refund the customer&apos;s monies paid. </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>9. Payment & Refunds</h3>
          <p>
          9.1 Payment is accepted via credit card (Visa, Mastercard or American Express), Discovery Miles, eBucks, SnapScan, Zapper, Ozow, Mobicred, via store credit (a “wallet”) and direct EFT transfer. Online credit card transactions will be acquired for OneDayOnly via Wirecard Solutions South Africa (Pty) Ltd ("Wirecard") and PayU Payment Solutions (Pty) Ltd (“PayU”). Wirecard and PayU use the strictest form of encryption, namely Secure Socket Layer 3 (SSL3), and no credit card details are stored on their websites. Users may go to their websites (www.wirecard.co.za and www.payu.co.za) to view their security certificates and security policies. Customer details will be stored by OneDayOnly separately from card details which are entered by the client on Wirecard and PayU&apos;s secure sites. OneDayOnly takes all reasonable steps to scrutinise all transactions to prevent attempted fraud and a transaction may be refused if OneDayOnly is not satisfied with its legitimacy.
        </p>
        <p>
        9.2 EFT payments need to be made to one of OneDayOnly&apos;s nominated bank accounts. The beneficiary reference (the reference that is going to reflect on OneDayOnly&apos;s bank account) needs to be the customer order number. Proof of payments need to be sent to eft@onedayonly.co.za in PDF format within 2 hours of the order being placed. Failure to send a proof of payment in time may lead to the order being cancelled, in which case OneDayOnly will only be liable to refund any monies paid.
        </p>
        <p>
        9.3 No forex or international EFT-payments will be accepted. Any costs involved with the acceptance or refusal of forex payments will be for the account of the customer.
        </p>
        <p>
        9.4 Refunds will be processed in the form of store credit, a “wallet”, which can be used towards future purchases on OneDayOnly. A customer may elect to receive a refund in lieu of store credit by means of an EFT, card reversal, Mobicred reversal or eBucks reversal. eBucks, EFT payments, Zapper, SnapScan and OZOW payments may only be reversed by means of an EFT transfer. Where a customer provides OneDayOnly with the incorrect account information, and a refund is successfully processed to the provided details, OneDayOnly will not be held responsible for any further refunds. Card reversals may take up to 14 business days to reflect. A valid proof of refund by OneDayOnly&apos;s card processing partner shall be conclusive proof that a card reversal has been processed. Should a refund not reflect, the customer will have to approach their card issuing institution to investigate the matter.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>10. Agreements of Sale</h3>
          <p>
          10.1 Placing an item in a shopping basket, or adding it to a wishlist without completing the purchase cycle, does not constitute an agreement of sale between OneDayOnly and the purchaser. Users cannot hold OneDayOnly liable if such items are not available when the purchase cycle is completed; and OneDayOnly may remove such an item from the shopping basket if no stock is available. An agreement of sale between OneDayOnly and a user only comes into effect if and when payment is received and the order is confirmed and processed by OneDayOnly during normal business hours (9am – 5pm). OneDayOnly reserves the right to refuse to accept and/or execute an order without giving any reasons. OneDayOnly also reserves the right to in its sole discretion cancel orders in whole or in part as circumstances dictate, in which event OneDayOnly shall only be liable to refund monies already paid by the user.
        </p>
        <p>
        10.2 A customer is entitled to cancel their order, provided that it has not yet been processed. If it has been processed, our Returns policy will apply.  Some orders may not be cancelled after they have been placed e.g. travel deals, voucher codes or personalised items.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>11. Returns Policy</h3>
          <p>OneDayOnly will only accept returns in accordance with this policy, the Consumer Protection Act 68 of 2008, the Electronic Communications & Transactions Act 25 of 2002 and any other applicable law. Our returns policy needs to be read with section 12, our standard warranty policy as well as our <a href="/about-returns">returns</a> page on the website. See section 9 for more info about refunds.</p>
          <p>
          11.1 Items may only be returned if they are faulty, damaged on arrival, incorrectly delivered or where the customer changes their mind within the parameters set out below and as set out in the Consumer Protection Act 68 of 2008.
        </p>
        <p>
        11.2 Once a customer informs OneDayOnly of a return, it is the customer&apos;s responsibility to ensure that the item is returned within 10 days after first contact was received.
        </p>
        <p>
        11.3 All returns need to be in original packaging, with all original accessories, parts and documentation.
        </p>
        <p>
        11.4 No items may be returned without prior written authorisation from OneDayOnly. OneDayOnly will not be liable for any items lost in transit to OneDayOnly or items incorrectly handed over to couriers where no prior written authorisation has occurred. OneDayOnly will issue a returns form or returns authorisation number once the return has been authorised, which needs to accompany the return. The absence of this form or returns authorisation number may lead to a return not being processed, for which OneDayOnly will not be held liable.
        </p>
        <p>
        11.5 Faulty and damaged on arrival items will be dealt with in accordance with sections 55 and 56 of the Consumer Protection Act 68 of 2008.
        </p>
        <p>
        (i) In the case of damaged on arrival items, the customer needs to notify OneDayOnly of any breakages, missing or damaged parts and accessories within 3 days of the receipt of the goods. OneDayOnly may ask for images of the goods and packaging, highlighting the extent of the damage. OneDayOnly will not entertain any claims of breakages, missing or damaged parts and accessories if this notification is not received within 3 days of the goods being delivered.
        </p>
        <p>
        (ii) (a) Faulty items may be returned within the warranty period. If a warranty period is not indicated on the deal, a 6-month standard warranty will apply. Faulty items will be repaired or replaced.  Where a repair or replacement is not possible, the customer will be refunded or credited.
        </p>
        <p>
        (b) OneDayOnly will cover the freight and insurance cost of a faulty item under warranty. Should our suppliers assess the item and find it to not be faulty or to be user damage, the customer may be liable for the return cost.
        </p>
        <p>
        (c) A faulty item is a defective item with any material imperfection in the manufacture of a product or any characteristic of a product which makes the product less acceptable than one would reasonably be entitled to expect in the circumstances.
        </p>
        <p>
        (d) The following does not constitute a defect, and will not be eligible for a refund, replacement or repair:
        </p>
        <ul>
          <li>
          faults resulting from normal wear and tear;
          </li>
          <li>
          damage arising from negligence, user abuse and misuse, or incorrect usage of the product;
          </li>
          <li>
          damage arising from electrical surges or sea air corrosion;
          </li>
          <li>
          damage arising from a failure to adequately care for the product;
          </li>
          <li>
          damage arising from unauthorised alterations to the product;
          </li>
          <li>
          where the specifications of a product, although accurately described on the website and generally fit for its intended purpose, do not suit the customer;
          </li>
          <li>
          in relation to Unboxed Deals, signs of handling and/or repackaging.

          </li>
        </ul>
        <p>
        (e) In assessing whether an item is defective or not, OneDayOnly may rely on their suppliers or independent assessment centres for feedback. In these cases, OneDayOnly&apos;s supplier feedback will be final.
        </p>
        <p>
        11.6 A customer is allowed to return an item within 7 days of receipt of the item if it is not faulty, subject to the following conditions:
        </p>
        <p>
        i) The customer writes in to OneDayOnly within 7 days of receipt of the item. Requests for returns outside of the 7-day window may not be entertained unless it is faulty in terms of section 11.5, subject to those provisions.
        </p>
        <p>
        ii) The item must be in a re-sellable condition, in original packaging and include all original accessories, parts and documentation. OneDayOnly will inspect the item on return and if it is not in a re-sellable condition, dispatch it back to the customer.
        </p>
        <p>
        iii) Certain items may not be returned once opened. This includes swimwear, underwear, cosmetic-or personal hygiene items, fragrances, DVD&apos;s, CD&apos;s, games, software, foodstuffs, supplements, adult toys and accessories, animal feed, cleaning products, medical equipment, personal protective equipment, certain jewellery items or items that have been made to the customer&apos;s specifications.
        </p>
        <p>
        iv) Certain redemption vouchers may not be refunded once it has been issued to the customer via email.
        </p>
        <p>
        v) Returns may be arranged on a customer&apos;s behalf, or a customer may courier their goods back to OneDayOnly&apos;s distribution centres under certain circumstances. A customer may also drop off their return at OneDayOnly&apos;s distribution centre, subject to prior approval.
        </p>
        <p>
        vi) Returns under section 11.6 will be at the Customer&apos;s cost. This cost will be offset against any refund or credit owed to the customer after an item has been returned.
        </p>
        <p>
        vii) OneDayOnly may arrange a third-party courier to collect these goods. The customer needs to be available during a pre-arranged slot to hand the goods to the courier. The goods need to be handed over to the correct courier and OneDayOnly will not be liable for goods handed to the incorrect courier. OneDayOnly will attempt two collections from the customer. No further collections will be attempted after two collections if the collection fails due to the customer (e.g. not available), and the customer will then have to arrange a return with their own courier at their own cost.
        </p>
        <p>
        11.7 Returns on incorrectly received items will be accepted subject to the following conditions.
        </p>
        <p>
        i) The customer needs to notify OneDayOnly of any incorrectly received goods within 3 days of the receipt of the goods. OneDayOnly may ask for images of the goods and packaging. OneDayOnly will not entertain any claims of incorrectly delivered goods if this notification is not received within 3 days of the goods being delivered.
        </p>
        <p>
        ii) The item must be in a re-sellable condition, in original packaging and include all original accessories, parts and documentation. OneDayOnly will inspect the item on return and if it is not in a re-sellable condition, dispatch it back to the customer.
        </p>
        <p>
        iii) The return of the item will be at OneDayOnly&apos;s cost. OneDayOnly may arrange a third-party courier to collect these goods. The customer needs to be available during a pre-arranged slot to hand the goods to the courier. The goods need to be handed over to the correct courier and OneDayOnly will not be liable for goods handed to the incorrect courier. OneDayOnly will attempt two collections from the customer. No further collections will be attempted after two collections if the collection fails due to the customer (e.g. not available), and the customer will then have to arrange a return with their own courier at their own cost.
        </p>
        <p>
        iv) Returns may be arranged on a customer&apos;s behalf, or a customer may courier their goods back to OneDayOnly&apos;s distribution centres under certain circumstances. A customer may also drop off their return at OneDayOnly&apos;s distribution centre, subject to prior approval.
        </p>
        `,
        },
      ],
      [
        {
          copy: `
          <h3>12. Standard Warranty Policy</h3>
          <p>OneDayOnly&apos;s standard warranty policy should be read with section 11, our returns policy.</p>
          <p>
          12.1 OneDayOnly provides a 6-month warranty on all products sold on its website against defects or poor quality from the date of delivery. Where products are not subject to an extended supplier warranty, we cannot facilitate any returns outside of this 6-month period. Some consumable goods may not be subject to this warranty due to expiry dates.
        </p>
        <p>
        12.2 Where a product has a supplier&apos;s warranty that extends beyond the 6-month Standard Warranty, such product can be returned within the extended supplier warranty period after delivery of the product. Please note that any extended supplier warranty is subject to the terms and conditions of the supplier or manufacturer. These are usually stated in a brochure or leaflet inside or on the product packaging, and may include the online registration of an extended warranty. It is the customer&apos;s responsibility to make themselves aware of any such terms and conditions.
        </p>
        <p>
        12.3 Parallel/Grey Imports – Any products indicated to be parallel/grey imports have been imported without the approval, or license of the registered owner of the trademark and therefore no guarantee or warranty in respect of such goods will be honoured or fulfilled by any official or licensed importer of such goods. Any warranty claims on such products will be covered by OneDayOnly or the relevant third-party seller for the warranty period indicated for any specific product, alternatively where no such warranty period has been indicated, for a period of 6 months from the date of receipt.
        </p>
        `,
        },
      ],
      [
        {
          copy: `
          <h3>13. Marketing and Special Promotions:</h3>
          <p>13.1 By submitting an order on our check out page, you agree to receive daily newsletters and marketing material from OneDayOnly.
        </p>
        <p>13.2 Every effort is made to feature all products shown on any sales promotional material. However, should a specific product become unavailable for any reason, OneDayOnly reserves the right to use that product image for all promotional elements without the guarantee of selling that product on the day.
        </p>
        <p>
        13.3 For the "Tiered Savings" sales promotion, see specific <a href="https://www.onedayonly.co.za/tiered-sales-terms-and-conditions/" target="_blank">terms and conditions</a> applicable to this promotion.
        </p>
        <p>
        13.4 For the "One Two Free Four" sales promotion, see specific <a href="https://www.onedayonly.co.za/one-two-free-four-ts-and-cs" target="_blank">terms and conditions</a> applicable to this promotion
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>14. Applicable Law</h3>
          <p>
          14.1 This site is hosted, controlled and operated from the
          Republic of South Africa and therefore governed by South African
          law.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>15. Restrictions on Sales</h3>
          <p>
          15.1 Alcohol & Tobacco products: Alcohol and tobacco products
          are not sold to persons under the age of eighteen years.
        </p>
        <p>
          15.2 DVD&apos;s and Videos: The onus is on the purchaser to
          ensure that age restrictions on above products are observed.
          Most of the DVDs available for purchase on OneDayOnly are
          encoded for use in region 2 or are encoded for multiple zones.
          DVD&apos;s encoded for other zones will be indicated as such.
          Please note that it is your responsibility to ensure that you
          purchase DVD&apos;s of the correct zone.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>16. Personal Data</h3>
          <p>
          16.1 OneDayOnly shall take all reasonable steps to protect the
          personal information of Users. For the purpose of this clause,
          &quot;personal information&quot; shall be defined as detailed in
          the Promotion of Access to Information Act 2 of 2000.
        </p>
        <p>
          16.2 OneDayOnly will store the data provided by buyers in a data
          file. Such data will be used to execute buyers&apos; orders and
          will be kept as long as necessary to handle any complaints about
          the execution of an order. No data will be passed on to third
          parties if such should jeopardise the buyer&apos;s privacy.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>17. Changes To Agreement</h3>
          <p>
          17.1 OneDayOnly may, at its sole discretion, change this
          agreement or any part thereof at any time without notice.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>18. Intellectual Property Rights</h3>
          <p>
          18.1 All the content, trademarks and data on this web site,
          including but not limited to, software, databases, text,
          graphics, icons, hyperlinks, private information, designs and
          agreements, are the property of or licensed to OneDayOnly and as
          such are protected from infringement by local and international
          legislation and treaties.
        </p>`,
        },
      ],
      [
        {
          copy: `
          <h3>19. Domicilium</h3>
          <p>
          19.1 OneDayOnly chooses as its domicilium citandi et executandi
          for all purposes under this agreement, whether in respect of
          court process, notice, or other documents or communication of
          whatsoever nature Unit G06 - The Old Castle Brewery, 6 Beach
          Road, Woodstock, 7925, South Africa.
        </p>`,
        },
      ],
    ],
  },
  {
    slug: 'competitions',
    contentTitle: 'Competitions',
    meta: {
      title: 'OneDayOnly Competitions and Promotions',
      keywords: 'onedayonly, competitions, promotions',
      description: 'Win big with OneDayOnly; enter our competitions!',
    },
    body: [
      [
        {
          title: 'Current Competitions and Promotions',
          titleColor: blue,
          panelColor: lightBlue,
          copy: `<table width="100%" cellpadding="6" align="center">
            <tr><td>Stor-age</td><td></td></tr>
            <tr><td>Bottles</td><td></td></tr>
            <tr><td>SMEG</td><td></td></tr>
            <tr><td>Afrihost</td><td></td></tr>
            <tr><td>OneDayOnly Vouchers</td><td></td></tr>
            </table>`,
        },
      ],
      [
        {
          title: '2019',
          copy: `<table width="100%" cellpadding="6" align="center">
            <tr><td>Reebok</td><td>Sonos</td><td>Freddy</td></tr>
            <tr><td>Flysafair</td><td>Huawei</td><td>Makalali</td></tr>
            <tr><td>Faithful-to-Nature</td><td>Philips</td><td>Seiko</td></tr>
            <tr><td>MasterStart</td><td>OneDayOnly Survey</td><td>SMEG</td></tr>
            <tr><td>90% off</td><td>Decofurn</td><td>Pentravel</td></tr>
            <tr><td>Zando</td><td>Reebok</td><td>Mweb</td></tr>
            <tr><td>ORMS</td><td>Riedel Wine Decanter</td><td>Sneakers</td></tr>
            <tr><td>Bottleshop</td><td>IGO</td><td>Bose</td></tr>
            </table>`,
        },
      ],
      [
        {
          title: '2018',
          copy: `<table width="100%" cellpadding="6" align="center">
            <tr><td>Boney M</td><td>Big Ass TV</td><td>Samsung</td></tr>
            <tr><td>Africa Stay</td><td>Get Wine</td><td>ODO 8th Birthday</td></tr>
            <tr><td>MiCasa</td><td>Reebok</td><td>Big Concerts</td></tr>
            <tr><td>Wellness Warehouse</td><td>Christmas in July</td><td>Galileo</td></tr>
            <tr><td>Win a Car</td><td>Siemens</td><td>Bucket List</td></tr>
            <tr><td>Uber Eats</td><td>bidorby</td><td>Zando</td></tr>
            <tr><td>SAA</td><td>Katy Perry</td><td>Google Home</td></tr>
            <tr><td>Playstation</td><td>Travelstart</td><td>Mac Book Air</td></tr>
            <tr><td>Most SA Prize</td><td>KitchenAid</td><td>SMEG</td></tr>
            <tr><td>Sorbet</td><td>Cartoon Network Live</td><td>Zapper</td></tr>
            <tr><td>12Free4 Sales Promotion</td><td>Drone</td><td>Polaroid Snap</td></tr>
            <tr><td>Flysafair</td><td>Nu Metro</td><td>Xbox</td></tr>
            <tr><td>SweepSouth</td><td>Nintendo</td><td>DialDirect</td></tr>
            </table>`,
        },
      ],
    ],
  },
  {
    slug: 'about-pargo',
    contentTitle: 'Pargo',
    meta: {
      title: 'OneDayOnly Pargo Shipping Information',
      keywords: 'onedayonly, shipping, daily deals',
      description: 'Getting your OneDayOnly purchases via Pargo Shippping',
    },
    header: {
      title: 'About Pargo',
      copy: `<h3 style="color:${blue}; font-family:Montserrat,sans-serif; margin-bottom:13px;">Everybody loves online shopping. Nobody enjoys
    sitting around all day, not daring to even go to the loo, because you're
    expecting a parcel.</h3>
    <p style="margin-bottom:12px">
    Pargo understands that parcel delivery is about convenience, speed and  reliability. You'll never have to wait at home all day for
        your parcel or miss a delivery again. Pargo delivers your parcels to
        a store near you.`,
    },
    body: [
      [
        {
          copy: `
          <h3 style="margin-top: 10px;">Pargo delivers in 3 steps</h3>

        <table width="100%" style="margin: 1em 0">
        <tr>
        <td width="70px" align="left">
        <img src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2OC4wNyA1NS44MiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNiOGM0Y2Q7fTwvc3R5bGU+PC9kZWZzPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjguMTQiIGN5PSI1MC4zMiIgcj0iNS41Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI1NC41NCIgY3k9IjUwLjMyIiByPSI1LjUiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02My45NCw5LjEzSDE5LjUxTDE3LjczLDJhMi42OSwyLjY5LDAsMCwwLTIuNTYtMkgyLjYzQTIuNjEsMi42MSwwLDAsMCwwLDIuNjMsMi42MSwyLjYxLDAsMCwwLDIuNjMsNS4yNkgxMy4xMkwyMCwzM2wxLjE2LDUuNzdhNC4xNSw0LjE1LDAsMCwwLDQuMDcsMy4zMkg1OC44N2E0LjE1LDQuMTUsMCwwLDAsNC4wNy0zLjMybDUtMjQuNjZBNC4wOCw0LjA4LDAsMCwwLDYzLjk0LDkuMTNaIi8+PC9zdmc+" width="40px" style="margin-bottom: 20px; margin-top:10px;" />
        </td>
        <td style="max-width:250px; padding-bottom: 13px;">During checkout, select one of more than 1000 locations for delivery.</td></tr>
        <tr><td align="left">
      <img src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4Ni43NiA2Ny43OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNiOGM0Y2Q7fTwvc3R5bGU+PC9kZWZzPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjEuNjkiIGN5PSI1OS42NSIgcj0iOC4xMyIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY1LjA3LDUxLjUyYTguMTMsOC4xMywwLDEsMCw4LjE0LDguMTNBOC4xMyw4LjEzLDAsMCwwLDY1LjA3LDUxLjUyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTg1LjkxLDMyLjgzLDcxLjM1LDE0LjYyYTMuMTQsMy4xNCwwLDAsMC0yLjE5LTEuMDZINTQuMjNWNS40NEE1LjQxLDUuNDEsMCwwLDAsNDguODMsMEg1LjRBNS40Miw1LjQyLDAsMCwwLDAsNS40VjU0LjI1YTUuNDEsNS40MSwwLDAsMCw1LjQzLDUuNGg1LjQyYTEwLjg1LDEwLjg1LDAsMSwxLDIxLjY5LDBINTQuMjNhMTAuODUsMTAuODUsMCwxLDEsMjEuNjksMGg1LjQyYTUuNCw1LjQsMCwwLDAsNS40Mi01LjR2LTE5QTQuNDUsNC40NSwwLDAsMCw4NS45MSwzMi44M1pNNTQuMjMsMzUuMjVWMTlINjcuNzhMODEuMzQsMzUuMjVaIi8+PC9zdmc+" width="40px"  style="margin-bottom: 20px;"/></td>

        <td style="padding-bottom: 13px;">Wait for delivery. You'll receive an
        SMS text message when ready.</td></tr>

        <tr><td align="left">
        <img src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NiA2Ni44OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNiOGM0Y2Q7fTwvc3R5bGU+PC9kZWZzPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSI2OC40IDAgOC4wMSAwIDEuMTcgMTguOTUgNzQuODggMTguOTUgNjguNCAwIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCwyMi4xN1Y2Ni44OEg3NlYyMi4xN1pNMTguMzksNDkuMjJhNS43Niw1Ljc2LDAsMCwxLTQuNTQsNS42MXYzLjdIMTd2Mi4zOEg4LjM2VjU4LjUzaDMuMTF2LTMuN2E1Ljc2LDUuNzYsMCwwLDEtNC41NC01LjYxVjQzLjQ5SDE4LjM5Wm0yNy44NywySDQwLjA3djYuMDZhMy42NCwzLjY0LDAsMSwxLTcuMjcsMFY1NC44NWgyLjQydjIuNDJhMS4yMiwxLjIyLDAsMCwwLDEuMjEsMS4yMiwxLjMxLDEuMzEsMCwwLDAsMS4yMi0xLjIyVjUxLjIxSDMxLjM0VjQ5LjRhNy40Nyw3LjQ3LDAsMCwxLDE0LjkyLjZabTIxLjg2LDFMNjQuOSw0OVY2MUg2MS41M1Y0OWwtMy4yMiwzLjIxTDU2LDQ5LjgxbDcuMjYtNy4yNyw3LjI3LDcuMjdaIi8+PC9zdmc+" width="40px"  style="margin-bottom: 40px;"/>
</td>
        <td style="padding-bottom: 13px;">Collect with said SMS and your ID.
        Go home and enjoy your new stuff.</td></tr>
        <tr><td colspan="2"><iframe
              title="product-video"
              src="https://www.youtube.com/embed/isrTTUVCMtI"
              frameBorder="0"
              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              width="100%"
              height="300px"
              referrerPolicy="origin"
            /></td></tr>
        </table>`,
        },
      ],
    ],
  },
  {
    slug: 'about-discovery-miles',
    contentTitle: 'Discovery miles',
    meta: {
      title: 'OneDayOnly payment with Discovery Miles',
      keywords: 'onedayonly, payments, daily deals, discovery miles',
      description: 'Pay with Discovery Miles',
    },
    header: {
      title: 'Spend your Discovery Miles with us',
      copy: `<h3 style="color:${blue}; font-family:Montserrat,sans-serif; margin-bottom: 15px;">Discovery Miles is the rewards currency that you can earn for getting healthy, driving well and spending responsibly. And you can spend your Discovery Miles right here.</h3>`,
    },
    body: [
      [
        {
          copy: `

        <h3>1. Spot a deal </h3>
         <p>Choose what you want to buy in the usual way, adding the items to your cart.</p>

        <h3>2. Choose Discovery Miles</h3>
         <p>In checkout, select to pay with Discovery Miles and click “submit order”.</p>

        <h3>3. Log in securely</h3>
         <p>You\'ll be redirected to a secure Discovery Miles page,
        operated by PayU. Log in with your <span style="color: ${blue}; font-weight: bold">discovery.co.za</span> user name and password.</p>

        <h3>3. Log in securely</h3>
         <p>You&apos;ll be redirected to a secure Discovery Miles page, operated by PayU. Log in with your Discovery Miles user name and password. You will be prompted to add the one-time password (OTP) sent to your phone.</p>

        <h3>4. Pay using Discovery Miles and rands</h3>
         <p>On the next screen, select the amount of Discovery Miles to use for your order. Your amount to pay will show on the left. Note: you can pay the full amount of your order with Discovery Miles. Or, if you don&apos;t have enough Discovery Miles, you can pay the outstanding amount with your Discovery Card or any Visa, Mastercard or American Express credit card by completing the details in the credit card section.</p>

        <h3>5. Note your order confirmation number.</h3>
         <p>After you confirm the payment, you&apos;ll be directed to the OneDayOnly.co.za order confirmation page, showing your order number. You will also get an SMS confirming the amount spent. Your order will soon be on its way!
         </p>
         <p>
         Order not successful? Please try again using the same process of adding the items to your cart. Note: if you haven&apos;t paid successfully with Discovery Miles, your order will be cancelled automatically.
         </p>

        <h3>Need help paying with Discovery Miles?</h3>
       <p>Please contact  <a style="color:${blue};font-weight: bold" href="mailto:customerservice@onedayonly.co.za">customerservice@onedayonly.co.za</a>. For queries about your Discovery Miles, please call Discovery Card on 0860 11 22 73.</p>
       <p>
       <b>Happy shopping with your Discovery Miles on OneDayOnly.co.za!</b>
       </p>
       `,
        },
      ],
    ],
  },
  {
    slug: 'privacy',
    contentTitle: 'Privacy',
    meta: {
      title: 'OneDayOnly Privacy Policy',
      keywords: 'onedayonly, privacy, popi',
      description: 'OneDayOnly Privacy Policy',
    },
    header: {
      title: 'Our privacy pledge',
      copy: `<p style="margin-bottom: 12px;">It was brought to our attention that, since we're capturing
    your details, we should have a privacy policy in place. Fair enough.</p>
    <p>We had a look around and found two options:
    we </p><p>1) copy/paste someone
    else's, and replace some other company's name with ours or <p  style="margin-bottom: 12px;">2) get a
    legal firm to draft one for us. <p style="margin-bottom: 12px;">Option one is lame and option two
    bloody expensive. And we're all about not being lame and being
    cheap.</p>
    <p>So, here's our best effort at explaining what data we
    capture, what we do with it and –more importantly- what we
    don't do with it.</p>
    <p  style="margin-bottom: 12px;">This is not a legal document, but rather an
    explanation in laymen's terms of what we do and don't do.
    A Privacy Policy suitable to the good viewers of Sesame Street,
    if you will.</p>
    `,
    },
    body: [
      [
        {
          copy: `<h3 style="font-family:Montserrat,sans-serif">Email Address Database</h3>
          <p>We collect your email addresses for inclusion in our
          daily email. This only happens with
          your express consent: when you leave an email address in the
          subscribe box, you will receive an email asking you to confirm.
          This is called a "double opt-in" and is considered best practice
          in countries where governments are highly concerned about their
          citizen's privacy. In South Africa this is not required, but we
          decided to do this anyway. </p>
          <p>We use Mailchimp.com for our email communications,
          and we have a database on their website containing your email
          address, your name (in some cases, since it's optional),
          and on what page on our website or Facebook you signed up.
          Mailchimp is continuously doing everything in their power to
          make sure that data is safe. We trust them implicitly with this
          task, not in the last place since they are one of the biggest in
          this field and they quite clearly know what they're doing.</p>
          <p><span style="font-weight:bold">Our pledge:</span> when you signed up to our
          mailing list, you did so because you want to receive emails from
          us, and not from someone else. We will never, ever, sell your email
          address to anyone else. Occasionally, we may include a 3rd party
          promotion in our emails to you, but this will be in line with what
          we do. We have your best interest at heart and would only send you
          something that we feel would be of genuine interest to you.</p>
          <h3 style="font-family:Montserrat,sans-serif">Personal Data on OneDayOnly.co.za</h3>On our own
          website we capture your name, billing and delivery addresses,
          contact details and your order history. There is no real top-secret
          information here, and we do trust our website's security.</p>
          <p><span style="font-weight:bold">Our pledge:</span> It's really safe. But if the
          worst possible thing would happen and this data got out, no-one
          would get hurt.<h3 style="font-family:Montserrat,sans-serif">Payment details</h3>We would never trust ourselves with
          building a website that will securely hold such critical data as
          credit card numbers. So we use Wirecard.co.za and PayU.co.za for
          this specific reason. We do send data to them (including your
          order number and the amount payable) and receive data back from
          them (basically whether the transaction was successful).
          On the payment providers\' dashboards, we can see the first
          6 and the last 4 digits of your credit card number, the
          card holder, issuing bank and the country in which that bank
          operates, but NOT the expiration date, CVC numbers, your bank
          balance, medical history or star sign. At no point do we have
          access to enough data to reproduce your credit card. We can
          only charge your card after you have given your express
          consent: the only change we can make to a payment is a
          reduction, by reversing an authorisation or refunding a
          payment. We cannot, under any circumstances, increase the
          amount that you have given authorisation for.</p>
          <p><span style="font-weight:bold">Our pledge:</span> we promise to always leave
          the handling of highly sensitive credit card data over to people
          that really know what they're doing. We may switch to taking
          credit card payments on our own website at some point, but
          this would only happen when we can guarantee the safety of
          this data and the transfer thereof between the necessary parties
          involved.</p>
          <p>eBucks payments are done in the exact same
          fashion and the above also goes for that.</p>
          <p>EFT payments are a bit different, but the
          risks apparently perceived by some are greatly exaggerated.
          As in, completely. When you make an EFT payment into our
          account, we can not see your account number (mind you,
          even if we wanted, we couldn't do anything with it).</p>`,
        },
      ],
      [
        {
          copy: `<h3 style="font-family:Montserrat,sans-serif">Facebook</h3>
            You can login to our website
            using the Facebook connect button. We do that so you can
            skip the somewhat painful process of registering with us.
            Connecting to Facebook allows us to pull some information from
            your Facebook account, but we don't do that.
            This also enables us to post on your Wall, but we have no
            intention of doing so. When we change our minds,
            we'll let you know in a way that can't be missed.</p>
            <p><span style="font-weight:bold">Our pledge:</span> Facebook
            is pretty awesome and we want to keep it that way by not being
            the kind of people that steal your data or post
            stuff on your wall without your consent.</p>
            <h3 style="font-family:Montserrat,sans-serif">Payment Details on OneDayOnly.co.za</h3><p>Occasionally,
            we receive fraudulent transactions. These usually
            stick out like a sore thumb, so these credit card
            authorisations are not settled and the orders not
            processed. We try to spot all of them, but sometimes one
            slips through. In that case,
            we are contacted by the card issuing bank, the payment is
            reversed and OneDayOnly's
            private army of ex-SWAT personnel is dispatched to collect
            the goods paid with a stolen credit
            card.</p><p><span style="font-weight:bold">Our pledge:</span> we hate criminals
            and will do everything in our
            power to make their lives blow.</p>
            <h3 style="font-family:Montserrat,sans-serif">The official bit</h3><p>The above, in legalese,
            states that
            OneDayOnly collects information (such as your name, shipping
            and billing address, email
            address, etc.) from you that we need to:
            <ul>
            <li>process your order;</li>
            <li>provide you with member support;</li>
            <li>allow you to use the community forums and
            participate in contests and other forum features; and</li>
            <li>send you newsletters and other communications such as polls,
            surveys, and special offers.</li>
            </ul></p>
            <p><em>OneDayOnly will set and access
            our own cookies on your computer to allow
            you to buy and interact at the site. We also use web beacons to
            gather anonymous, aggregated statistical information (e.g. unique
            hits, page views, etc.) about our website traffic.
            <p>OneDayOnly may share information
            collected by us with third parties to help process your order
            (e.g. shipping companies, credit card processors, etc.) or to
            provide statistical and demographic analysis to OneDayOnly to
            help us and our business partners provide you with better services
            and offerings.</p>
            <p>OneDayOnly will not share, rent,
            lease, or sell your
            personal information (e.g. your email address, your name, your
            address, etc.) to any third party for their independent use or
            benefit. Never. Ever.</p>
            <p>We hope this makes sense. Future changes
            to this Privacy Policy may be made at any time by sending
            you an email or posting notice of the changes on the site,
            with the changes effective 30 days after OneDayOnly's
            dispatch of the email or posting of the notice. To ask
            questions about this policy or to remove your personal
            information from our database, write us at
            customerservice@onedayonly.co.za: our people would love
            to tell you more about this.</p></em></p>`,
        },
      ],
    ],
  },
  {
    slug: 'about-ebucks',
    contentTitle: 'eBucks',
    meta: {
      title: 'Using EBucks on OneDayOnly',
      keywords: 'onedayonly, payments, ebucks, daily deals',
      description: 'Paying OneDayOnly with EBucks',
    },
    header: {
      title: 'Pay using both eBucks and Rands',
      copy: `<h3 style="color:${blue}; font-family:Montserrat,sans-serif; margin-bottom: 13px;">Not enough eBucks to cover the cost of the item you want to buy?
  Not to worry, because now you can pay using eBucks and Rands.</h3>
<p style="margin-bottom: 12px">
  Here&apos;s how you can get your hands on our amazing deals,
  despite your eBucks balance:
</p>`,
    },
    body: [
      [
        {
          copy: `
          <h3>1. Get the ingredients</h3>
          <p>You'll need your SA ID number or eBucks card number and a 4-digit eBucks PIN.</p>
          <p>If you do not have one, log into the eBucks website and select "send me a PIN". Alternatively, call the eBucks contact centre on 087 320 3200.</p>
          <p>Keep your cellphone handy too, because eBucks will send you a One Time Pin (OTP) when you're ready to pay with your eBucks.</p>

    <h3>2. Make your choice</h3>
    <p>Not that we have much choice. But when we do
(like a colour or size),
select the one you want and hit that big red <em>I Want One</em>
button to put it in your cart.</p>

     <h3>3. Choose eBucks</h3>
     <p>If you've followed the previous steps, you will now find yourself on our magical one-page checkout. It just gets easier from here:</p>
     <p>Choose eBucks as your payment option and fill out the required fields.</p>
     <p>Lastly, click submit order at the bottom and you'll be redirected to the payment gateway</p>

      <h3>4. Connect to eBucks.com</h3>
     <p>You'll be directed to the secure eBucks payment section
     automatically. Log in using your 4-digit eBucks PIN (see Step 1).
     <p>Your OTP will be sent to the cellphone number that appears on your eBucks account.</p>

     <h3>5. Check it out</h3>
     <p>In the secure payment section you\'ll be able to see the balances
     of any eBucks and qualifying FNB or RMB Private Bank Cheque Accounts that
     you have linked to your shopping profile. You can change which of your
     accounts to display on internet partner websites by visiting your
     Shopping profile within your eBucks account settings.
     <p>Tick the block next to the account you\'d like to pay with.
     You can tick your eBucks  account along with either your qualifying FNB
     or RMB Private Bank Cheque
     Account and decide how much you\'d like to pay from each.</p>
     <p>Click Pay. The amount will be directly debited from your eBucks or
     FNB or RMB Private Bank Cheque Account balance.</p>
     <p>A message confirming
     your purchase will
     appear. We suggest keeping this for your records. Now watch out for
     your delivery, because it will soon be on its way!</p>

     <h3>6. Not so fast, cowboy:</h3>
     <p>Paying using part cash, part eBucks does not currently cater for:
     <ul><li>FNB and RMB Private Bank Credit Card payments</li>
     <li>Other FNB or RMB Private Bank accounts that are not cheque accounts</p>
    `,
        },
      ],
    ],
  },
  {
    slug: 'about-shipping',
    contentTitle: 'Shipping',
    meta: {
      title: 'OneDayOnly Shipping Information',
      keywords: 'onedayonly, shipping, daily deals',
      description: 'How OneDayOnly ships your deals',
    },
    header: {
      title: 'Shipping',
      copy: `<p style="font-weight: bold;
    font-size: 1.2em;
    line-height: 1.5;
    color: ${blue}; font-family:Montserrat,sans-serif; margin-bottom:12px">Of course, we are aware that other companies offer free, same- or next-day shipping. That is why we've set up this little section; to explain how we operate and why we're different.</p>

    <p style="margin-bottom: 12px;">Free delivery is great. Fast delivery is great. But, since we're operating a unique business that is built on cost reductions, neither of the two are available without making a few big sacrifices.</p>
    <p style="margin-bottom: 12px;">And we don't want to do that, for the sake of our business. And for the sake of continuing to offer you our signature great deals.</p>

     <p>Some might call us "slow," but we prefer the term "cheap."</p>`,
    },
    body: [
      [
        {
          title: 'Why do I have to pay for shipping?',
          copy: `<h3 style="margin-bottom: 12px;">The short version:</h3> <p>
        Shipping costs money and we don't want to go bankrupt.</p>
        <h3 style="margin-bottom: 12px;">The long version:</h3>
         <p>Well, because we also have to pay for delivery. And that money needs to come from somewhere.</p>
         <p>We have debated the merits of offering free shipping at length but the reality is that – without some magic source of free cash – the only place that money can come from is from our customers.</p>
        <p>That leaves us with two options: hide it in the price of the product, or show it. We decided to be transparent and show it. This lets us cut our prices to the bare minimum and give you the best possible deals.</p>
        <p>If we had incorporated the shipping cost into the price of an item, you will pay more whenever you order more than one item. In reality, however, the cost of shipping doesn&apos;t necessarily go up with every additional item in a shipment.</p>
        <p>By the way: the actual shipping charge you pay is a best-effort approximation of what shipping is going to cost us. As a result, ordering a 3kg item to Sandton or Cape Town may work out cheaper than a 75g iPhone cover to Springbok. Don&apos;t blame us; blame the vast expanse that is our beautiful South Africa.</p>`,
        },
      ],
      [
        {
          title: 'Why does shipping take 5-10 working days?',
          copy: `<h3 style="margin-bottom: 12px;">The short version:</h3> <p>We don&apos;t hold stock. Our partners deliver exactly what we need, after a deal has run. That way we keep our costs down, prices low and everybody (including you) happy.</p>
        <h3 style="margin-bottom: 12px;">The long version:</h3>
        <p>We&apos;re not like other online shops with a fixed catalogue and tons of stock.</p>
        <p>So the day after you (and lots of others) have placed your orders, we go to our suppliers and place a massive, single order. Our suppliers love this, as it keeps things simple and moving along smoothly. Happy suppliers equal low prices.</p>
        <p>Our suppliers then deliver the required stock to us. This can take anywhere between 1 and 3 working days, depending on where the supplier is based. Once we&apos;ve received and checked the stock, we dispatch your order to you. This can also take anywhere between 1 and 3 working days, depending on where you&apos;re based.</p>
        <p>On very rare occasions, unforeseen delays can creep in. Often these are out of our control (stock issues on the side of the supplier, courier logistics delays) and we do try and mitigate these delays as much as possible.</p>
        <p>The time it takes to complete the delivery does add up, but it means we can offer our deals at the very best price point possible.</p>
        <p>As such, the practice of not holding stock is one of the core principles behind OneDayOnly&apos;s success.</p>
        <p>That, and our sparkling personalities of course.</p>`,
        },
      ],
    ],
  },
];

export default content;
